enum FundOrderType {
  PURCHASE = 'PURCHASE',
  REDEMPTION = 'REDEMPTION',
  SWITCH = 'SWITCH',
}

export default FundOrderType;
